import React from "react";
import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";

const PageLayout = ({ children }) => {
  return (
    <div className="flex min-h-screen flex-col">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
};

export default PageLayout;
